import type { JSX } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { isNavActive, MOBILE_TABS, type NavBadgeKey } from '../lib/nav';

/**
 * Нижняя панель на телефоне (HUB 2.0, план wk6 §3): 5 вкладок — Главная ·
 * Обучение · База · Задачи · Ещё. «Ещё» открывает выезжающее меню со всеми
 * разделами (drawer Layout). Видна только <768 px (CSS `.fk-hub-tabbar`),
 * учитывает «домашнюю полоску» iPhone (env(safe-area-inset-bottom)).
 * Цели касания — не меньше 48 px.
 */
export function MobileTabBar({
  badges,
  onMore,
  moreOpen,
}: {
  badges: Partial<Record<NavBadgeKey, number | null>>;
  onMore: () => void;
  moreOpen: boolean;
}): JSX.Element {
  const { pathname } = useLocation();
  // «Ещё» подсвечена, когда открыт drawer или текущий раздел не из первых четырёх.
  const inTabs = MOBILE_TABS.some((t) => !t.to.startsWith('#') && isNavActive(t, pathname));
  return (
    <nav className="fk-hub-tabbar" aria-label="Основные разделы">
      {MOBILE_TABS.map((t) => {
        const Icon = t.icon;
        const isMore = t.to === '#more';
        const active = isMore ? moreOpen || !inTabs : !moreOpen && isNavActive(t, pathname);
        const count = t.badge ? badges[t.badge] : null;
        const inner = (
          <>
            <span className="fk-hub-tab-ic">
              <Icon />
              {count ? <span className="fk-hub-tab-badge">{count > 99 ? '99+' : count}</span> : null}
            </span>
            <span>{t.label}</span>
          </>
        );
        return isMore ? (
          <button key={t.to} type="button" className="fk-hub-tab" data-active={active ? 'true' : 'false'} onClick={onMore} aria-expanded={moreOpen}>
            {inner}
          </button>
        ) : (
          <Link key={t.to} to={t.to} className="fk-hub-tab" data-active={active ? 'true' : 'false'} aria-current={active ? 'page' : undefined}>
            {inner}
          </Link>
        );
      })}
    </nav>
  );
}
